<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <v-card
    class="text-body-2 px-4 py-6"
    elevation="0"
    height="320"
    outlined
    style="position: relative"
    @click="$emit('click')"
  >
    <div
      class="d-flex flex-column"
      style="height: 100%"
    >
      <div
        class="d-flex align-center"
        style="height: 41px"
      >
        <div
          class="text-h4 font-weight-bold"
        >
          {{ name }}
        </div>
        <v-spacer/>
        <v-menu
          close-on-content-click
          left
          offset-overflow
          offset-y
          rounded
        >
          <template #activator="{on,attrs}">
            <v-btn
              icon
              style="border-radius: 12px"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>
                mdi-dots-vertical
              </v-icon>
            </v-btn>
          </template>
          <v-list
            outlined
            width="200px"
          >
            <v-list-item-group>
              <v-list-item @click="$emit('click')">
                <v-list-item-title>{{ $t('open') }}</v-list-item-title>
              </v-list-item>
              <v-list-item @click="deleteItem">
                <v-list-item-title>{{ $t('delete') }}</v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </div>
      <v-spacer/>
      <div>
        <div
          class="pa-1 px-1 d-flex "
        >
          <div class="text-body-1 font-weight-bold">
            #{{ code }}
          </div>
          <v-spacer/>
        </div>
        <div
          class="pa-1 px-1 d-flex "
        >
          <div class="text-body-1">
            {{ price | priceDisplay }}
          </div>
          <v-spacer/>
        </div>
        <div
          class="pa-1 px-1 d-flex "
        >
          <div class="text-body-2">
            {{ describe }}
          </div>
          <v-spacer/>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
  import { sureToDelete } from '@/common/utils'

  export default {
    name: 'CouponInfoCard',
    props: {
      couponInfo: {},
    },
    computed: {
      describe () {
        return this.couponInfo?.dishDesc || this.$t('no_description')
      },
      code () {
        return this.couponInfo?.code ?? ''
      },
      name () {
        return this.couponInfo?.dishName ?? ''
      },
      price () {
        return this.couponInfo?.price ?? ''
      },
      haveMod () {
        return this.couponInfo?.haveMod ?? 0
      },
    },
    methods: {
      async deleteItem () {
        await sureToDelete(() => {
          this.$emit('delete')
        })
      },
    },

  }
</script>

<style scoped>

</style>
